import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/auth/Login';
import TrackAdminDashboard from './components/trackAdmin/TrackAdminDashboard';
import SuperAdmin from './components/superAdmin/SuperAdmin';
import JudgeDashboard from './components/judge/JudgeDashboard';
import ProtectedRoute from './components/auth/ProtectedRoute';
import './global.css';

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Judge Routes */}
        <Route
          path="/judge"
          element={<ProtectedRoute allowedRoles={['j1', 'j2', 'j3', 'j4', 'j5', 'j6']} />}
        >
          <Route path="track/:trackId/dashboard" element={<JudgeDashboard />} />
        </Route>

        {/* Admin Routes */}
        <Route path="/admin" element={<ProtectedRoute allowedRoles={['admin']} />}>
          <Route path="dashboard" element={<TrackAdminDashboard />} />
        </Route>

        {/* Super Admin Routes */}
        <Route path="/super-admin" element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route path="dashboard" element={<SuperAdmin />} />
        </Route>

        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Login />} />
      </Routes>
    </Router>
  );
};

export default App;